import Vue from 'vue'
import formatDelay from '@/module/util/format-delay'
import actions from './actions'
import getters from './getters'
import mutations from './mutations'


export default {
	namespaced: true,
	state: {
		loading: {},
		event: {},
	},
	actions,
	getters,
	mutations
}
